// @flow

import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  fieldset: {
    border: 'solid 1px',
    borderColor: theme.palette.divider,
    margin: theme.spacing(1, 0),
    padding: theme.spacing(1, 2, 2),
    borderRadius: theme.shape.borderRadius,
  },
}))

type Props = {
  legend: string,
  children: React.Node,
}

function Fieldset({ children, legend }: Props) {
  const classes = useStyles()
  return (
    <fieldset className={classes.fieldset}>
      <Typography variant="caption" color="textSecondary" component="legend">
        {legend}
      </Typography>
      {children}
    </fieldset>
  )
}

export default React.memo<Props>(Fieldset)
